
const namespaced = true;

const state = {
  rootTabs: [
    { text: `Général`, path: `/settings/general` },
    { text: `Statuts`, path: `/settings/statuses` },
    { text: `Priorités`, path: `/settings/priorities` },
    { text: `Domaines`, path: `/settings/domains` },
    { text: `Tags`, path: `/settings/tags` },
    { text: `Utilisateurs`, path: `/settings/users` },
    { text: `Clients`, path: `/settings/clients` },
    { text: `Interventions récurrentes`, path: `/settings/recurrent-interventions` },
  ],
  aggregatorTabs: [
    { text: `Général`, path: `/settings/general` },
    { text: `Utilisateurs`, path: `/settings/users` },
    { text: `Sites`, path: `/settings/sites` },
    { text: `Prestataires`, path: `/settings/makers` },
    { text: `Tags`, path: `/settings/tags` },
    { text: `Statuts`, path: `/settings/statuses`, onlyForSelfMakers: true },
    { text: `Priorités`, path: `/settings/priorities`, onlyForSelfMakers: true },
    { text: `Domaines`, path: `/settings/domains`, onlyForSelfMakers: true },
  ],
  aggregatorMakerTabs: [
    { text: `Infos générales`, path: `/settings/makers/:makerId/infos` },
    { text: `Statuts`, path: `/settings/makers/:makerId/statuses` },
    { text: `Priorités`, path: `/settings/makers/:makerId/priorities` },
    { text: `Domaines`, path: `/settings/makers/:makerId/domains` },
    { text: `Utilisateurs`, path: `/settings/makers/:makerId/users`, hideOnSlugMaker: true },
  ],
};

const mutations = {
  SET_SEARCH_STRING(state, searchString) {
    state.searchString = searchString || ``;
  },
  SET_KEEPING_PREVIOUS_STATE(state, isKeepingPreviousState) {
    state.isKeepingPreviousState = isKeepingPreviousState;
  },
};

const actions = {};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
